import { ESearchResultsActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const openSearchResultsSidebar = actionGenerator<ESearchResultsActionType.SidebarOpened, boolean | void>(
  ESearchResultsActionType.SidebarOpened,
);
